import { h, Component } from 'preact';
import SearchInput from '../search-input';
import { withText } from 'preact-i18n';
import { withConfig } from '../../config';
import { trackingProvider, DIMENSION } from '@cube/track';

@withConfig([
	'search.semshopping.searchURL',
	'search.semshopping.queryParameter'
])
@withText({
	placeHolderText: 'searchProducts'
})
@trackingProvider({
	[DIMENSION.componentpath]: 'SemShopping'
})
export default class SemShopping extends Component {

	render( props ) {
		return <SearchInput {...props} />;
	}
}
